import React, { useEffect, useState } from "react";
import { CalendarDays, Clock, History } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";

function fmtDate(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

function EventCard({ e, past }) {
  return (
    <div className="glass card-hover rounded-2xl p-7 h-full flex flex-col" data-testid={`event-${e.id}`}>
      <div className="flex items-center gap-2 text-primary-c text-sm font-semibold">
        <CalendarDays size={16} /> {fmtDate(e.date)}
      </div>
      <h3 className="font-display font-bold text-xl text-t mt-3">{e.title}</h3>
      <p className="text-muted-c text-sm mt-2 flex-1">{e.description}</p>
      <span className={`inline-flex items-center gap-1.5 text-xs font-semibold mt-5 px-3 py-1 rounded-full w-fit ${past ? "text-muted-c" : "text-on-primary bg-primary-c"}`}
        style={past ? { background: "rgba(var(--surface-rgb),0.8)", border: "1px solid var(--border)" } : {}}>
        {past ? <><History size={12} /> Past Event</> : <><Clock size={12} /> Upcoming</>}
      </span>
    </div>
  );
}

export default function Events() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then(({ data }) => setEvents(data)).catch(() => {}); }, []);

  const upcoming = events.filter((e) => !e.archived).sort((a, b) => (a.date || "").localeCompare(b.date || ""));
  const past = events.filter((e) => e.archived).sort((a, b) => (b.date || "").localeCompare(a.date || ""));

  return (
    <div className="relative z-10 pt-28">
      <section className="mx-auto max-w-7xl px-5 py-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-primary-c">Events</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-t mt-4">What's <span className="text-primary-c">Happening.</span></h1>
          <p className="text-muted-c text-lg mt-5 max-w-2xl">Workshops, demo classes and celebrations at Bits &amp; Bytes.</p>
        </Reveal>

        <Reveal delay={0.05}><h2 className="font-display font-bold text-3xl text-t mt-14 mb-6 flex items-center gap-3"><Clock className="text-primary-c" size={24} /> Upcoming</h2></Reveal>
        {upcoming.length === 0 ? (
          <div className="glass rounded-2xl p-10 text-center text-muted-c">No upcoming events right now. Check back soon!</div>
        ) : (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {upcoming.map((e, i) => <Reveal key={e.id} delay={(i % 3) * 0.08}><EventCard e={e} past={false} /></Reveal>)}
          </div>
        )}

        {past.length > 0 && (
          <>
            <Reveal><h2 className="font-display font-bold text-3xl text-t mt-16 mb-6 flex items-center gap-3"><History className="text-primary-c" size={24} /> Past Events</h2></Reveal>
            <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
              {past.map((e, i) => <Reveal key={e.id} delay={(i % 3) * 0.08}><EventCard e={e} past /></Reveal>)}
            </div>
          </>
        )}
      </section>
    </div>
  );
}
